import { PayloadAction, createSlice, current } from "@reduxjs/toolkit";

import { clone } from "lodash";

import { LearnerProgress, Skill } from "@hubcapp/types";

import { LearnerState } from "./types";
import { getCategoryProgressPercentage } from "./utils";

export const initialLearnerState: LearnerState = {
  masterProgress: {
    overallProgress: 0,
    categories: [],
  },
  progress: {
    overallProgress: 0,
    categories: [],
  },
};

export const { actions: learnerActions, reducer: learnerReducer } = createSlice(
  {
    name: "learner",
    initialState: initialLearnerState,
    reducers: {
      progressUpdated: (
        state,
        action: PayloadAction<{ progress?: LearnerProgress }>,
      ) => {
        state.progress = action.payload.progress;
      },
      changeSkillScore: (
        state,
        action: PayloadAction<{ skillId: string; score: number }>,
      ) => {
        const newState = clone(current(state.progress)) as LearnerProgress;

        if (!newState) {
          return;
        }

        const category = clone(
          (newState.categories || []).find(cat =>
            cat.skills.find(skill => skill?.id === action.payload.skillId),
          ),
        );

        if (!category) {
          return;
        }

        category.skills = category?.skills.map(skill =>
          skill?.id === action.payload.skillId
            ? ({
                ...skill,
                score: action.payload.score,
              } as Skill)
            : skill,
        );

        category.progressPercentage = getCategoryProgressPercentage(
          (category.skills || []) as Skill[],
        );

        newState.categories = newState.categories.map(cat =>
          cat?.id === category.id ? category : cat,
        );

        newState.overallProgress = Math.ceil(
          newState.categories.reduce(
            (acc: number, { progressPercentage }) => acc + progressPercentage,
            0,
          ) / newState.categories.length,
        );

        state.progress = newState as LearnerProgress;
      },
      progressSaved: state => {
        state.masterProgress = clone(state.progress);
      },
    },
  },
);
